import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function ActionDetailArgoment({title, argument, methodParent, setArgument }: {title: string, argument: {note: string, argomento: string}, methodParent: any, setArgument: any }) {
    return (
        <button onClick={() => {methodParent(true); setArgument({title: title, argument: argument})}}>
            <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        </button>
    )
}